import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MediaSlotView } from "../render/context";
import { resolveSlotMedia } from "../render/slot-media";
import { Section } from "./_section";
/**
 * PlaygroundReelBlock — test-only band whose single slot takes a video and
 * nothing else (docs/briefs/playground-components.md §1). Serves the
 * media-kind stories' picture-refused-here example.
 */
const CONTAINER = "mx-auto max-w-7xl px-4 @min-[640px]:px-6 @min-[1024px]:px-8";
export function PlaygroundReelBlock({ data }) {
    const { heading, media } = data;
    return (_jsx(Section, { children: _jsxs("div", { className: CONTAINER, children: [_jsx("h2", { className: "text-2xl font-bold text-foreground", children: heading }), _jsx("div", { className: "mt-4", children: _jsx(MediaSlotView, { image: media, ratio: "16 / 9", label: "Reel", emptyRender: null }) })] }) }));
}
export function playgroundReelFromBlock(block, resolve) {
    return {
        heading: block.scalars?.heading ?? "",
        media: resolveSlotMedia(block, "media", resolve),
    };
}
export const playgroundReelBlockEntry = {
    Component: PlaygroundReelBlock,
    fromBlock: playgroundReelFromBlock,
};
//# sourceMappingURL=playground-reel.js.map